<template>
  <div class="editAdd">
    <p>接手人</p>
    <article>
      <ul>
        <li>
          <p><span>*</span>姓名:</p>
          <input
            type="text"
            placeholder="请输入接手人姓名"
            maxlength="15"
            v-model="name"/>
        </li>
        <li>
          <p><span>*</span>手机号:</p>
          <input
            type="tel"
            maxlength="14"
            minlength="7"
            v-model="mobile"
            placeholder="请输入手机号码"
            class="input-code"
            ref="input">
          </li>
          <li>
            <p><span>*</span>身份证号:</p>
            <input
              type="text"
              maxlength="20"
              minlength="7"
              v-model="idcard"
              placeholder="请输入身份证号码"
              class="input-code"
              ref="input">
          </li>
        <li>
          <p><span>*</span>邮箱:</p>
          <input
            type="text"
            maxlength="20"
            minlength="7"
            v-model="email"
            placeholder="请输入邮箱"
            class="input-code"
            ref="input">
        </li>
          <li>
            <p>银行卡号:</p>
            <input
              type="tel"
              minlength="7"
              v-model="bankcard"
              placeholder="请输入接手人银行卡号"
              class="input-code"
              ref="input">
        </li>
        <li>
          <router-link :to="'/openingbank?1=1' + arg">
            <div>
              <p>开户银行:</p>
              <input
                type="text"
                readonly
                v-model="bankname"
                placeholder="请输入开户银行"
                @input="handlechange('bankname')"
                class="input-code"
                ref="input">
            </div>

            <img src="../../assets/images/jt3.png">
          </router-link>
          </li>
        <li>*开户行请填写到支行，姓名需和银行卡持卡人一致，否则无法汇款</li>
      </ul>
    </article>
    <footer>
      <button class="btn" @click="submit">下一步</button>
    </footer>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'

export default {
  name: 'personinfofill',
  data () {
    return {
      name: '',
      mobile: '',
      idcard: '',
      email: '',
      bankcard: '',
      bankname: '',
      banknamechooseitem: null,
      arg: isApp()
    }
  },
  mounted: function () {
    console.log(1)
    if (isWeixin()) {
      fenxiang({path: 'personinfofill'})
    }

    this.getData()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.banknamechooseitem = sessionStorage.getItem('bank_name_choose_item') ? JSON.parse(sessionStorage.getItem('bank_name_choose_item')) : null
      vm.bankname = vm.banknamechooseitem ? vm.banknamechooseitem.name : ''
    })
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    mobile (n) {
      this.$nextTick(() => { //这里
        this.mobile = String(n).replace(/\D/g, '')
      })
    }
  },
  methods: {
    getData: function () {
    },
    submit: function () {
      if (this.name.trim().replace(/ /g, '') == '' || this.name == undefined || this.name == null) {
        this.$toast('接手人姓名不能为空')
        return
      } else if (this.mobile.trim().replace(/ /g, '') == '' || this.mobile == undefined || this.mobile == null) {
        this.$toast('手机号码不能为空')
        return
      } else if (this.idcard.trim().replace(/ /g, '') == '' || this.idcard == undefined || this.idcard == null) {
        this.$toast('身份证号码不能为空')
        return
      }else if (this.email.trim().replace(/ /g, '') == '' || this.email == undefined || this.email == null) {
        this.$toast('邮箱不能为空')
        return
      } else {
        if (!(/^1[3456789]\d{9}$/.test(this.mobile))) {
          this.$toast('手机号码有误，请重填')
          return
        }
      }
      var url = 'Wxmall/StoreChange/setMeinfo', data = {
        type: this.$route.query.storetype,
        id: this.$route.query.storeid,
        name: this.name,
        mobile: this.mobile,
        idcard: this.idcard,
        bankcardid: this.bankcard,
        email: this.email,
        bankname: this.bankname
      }
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code == 200) {
          this.$router.replace({
            path: '/identityauth?storeid=' + this.$route.query.storeid + '&storetype=' + this.$route.query.storetype + '&name=' + encodeURIComponent(this.name) + this.arg
          })
        }
      })
    },
    input_blur () {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange (n) {
      var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this[n].match(reg)) {
        this[n] = this[n].replace(reg, '')
      }
      this[n] = this[n].replace(/\s+/g, '')
    }
  }
}
</script>

<style scoped lang="scss">
  .editAdd {
    background: #ffffff;
    >p {
      height: 0.42rem;
      background: #F5F5F5;
      color: #333333;
      font-size: 0.15rem;
      line-height: 0.42rem;
      font-weight: 500;
      text-indent: 0.11rem;
    }
    ul {
      padding: 0 0.1rem 0 0.15rem;
      background: #fff;
      li {
        display: flex;
        align-items: center;
        height: 0.45rem;
        border-bottom: 0.005rem solid #D8D8D8;
        &:nth-last-of-type(2) {
          width: 100%;
          a {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          div {
            display: flex;
            align-items: center;
          }
          img {
            float: left;
            width: 0.1rem;
            height: 0.1rem;
            padding: 0 0.02rem 0;
            margin-top: 0.04rem;
            margin-left: 0.07rem;
          }
        }
        p {
          font-size:0.14rem;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:0.2rem;
          width: 0.82rem;
          span {
            color: red;
            padding-right: 0.05rem;
          }
        }
        input {
          border: none;
          outline: none;
          display: block;
          font-size: 0.14rem;
          color: #333;
          &::placeholder {
            color: #B7B7B7;
            font-size: 0.14rem;
          }
        }
        &:last-of-type {
          color: #FC0324;
          font-size: 0.12rem;
          border-bottom-width: 0;
          height: auto;
          margin-top: 0.08rem;
        }
      }
    }
    footer {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 0.63rem;
      padding: 0.1rem 0.11rem;
      .btn {
        border: 0;
        outline: none;
        border-radius: 0.25rem;
        display: block;
        font-size: 0.17rem;
        color:#FFFFFF;
        width: 100%;
        height: 100%;
        background:linear-gradient(90deg,#FC0324,#F63A66);
        background: -webkit-linear-gradient(90deg,#FC0324,#F63A66);
        background: -o-linear-gradient(90deg,#FC0324,#F63A66);
        background: -moz-linear-gradient(90deg,#FC0324,#F63A66);
        background: -ms-linear-gradient(90deg,#FC0324,#F63A66);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/storechange/personinfofill.vue